<template>
  <div class="pbc-component-condensed">
      <div v-if='!disableIcon' class="pbc-component-type-header">
        <div class="pbc-component-type-icon-parent">
          <component :is='icon' :size='iconSize' class="pbc-component-type-icon" />
        </div>
        <div class="pbc-component-type-name">{{dbentry.text}}</div>
      </div>
      <property-form v-if='showPropertyForm' :condensed='true' :model='component' :transform='transform' :schema="dataSchema" :partutil="partutil" :transforms-and-source="transformsAndSource" class="text-black overflow-hidden" />
  </div>
</template>
<script>
// This file is auto-generated
import CondensedComponentMixin from '@components/condensedComponentMixin.js';
import ComponentCondensedEditButton from '@ui/atoms/ComponentCondensedEditButton.vue';
import * as ComponentsDb from '@edit/tree/componentsdb.js';
export default {
  mixins: [CondensedComponentMixin],
  props: {
    showPropertyForm: {
      type: Boolean,
      default: true
    }
  },
  components: {
    ComponentCondensedEditButton
  }
}
</script>
